import createIcon from '../../createIcon';

/**
 * @component @name BeachAccess
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMTI3NyAxNC41NTg4TDE0LjU1NzcgMTMuMTI4OEwyMC45OTc3IDE5LjU3MThMMTkuNTcwNyAyMC45OTg4TDEzLjEyNzcgMTQuNTU4OFpNMTcuNDIwNyA4LjgyODc2TDIwLjI4MDcgNS45Njg3NkMxNi4zMzA3IDIuMDE4NzYgOS45MzA3MSAyLjAwODc2IDUuOTgwNzEgNS45NDg3NkM5LjkxMDcxIDQuNjQ4NzYgMTQuMjkwNyA1LjY5ODc2IDE3LjQyMDcgOC44Mjg3NlpNNS45NTA3MSA1Ljk3ODc2QzIuMDEwNzEgOS45Mjg3NiAyLjAyMDcxIDE2LjMyODggNS45NzA3MSAyMC4yNzg4TDguODMwNzEgMTcuNDE4OEM1LjcwMDcxIDE0LjI4ODggNC42NTA3MSA5LjkwODc2IDUuOTUwNzEgNS45Nzg3NlpNNS45NzA3MSA1Ljk1ODc2TDUuOTYwNzEgNS45Njg3NkM1LjU4MDcxIDguOTc4NzYgNy4xMzA3MSAxMi44NDg4IDEwLjI2MDcgMTUuOTg4OEwxNS45OTA3IDEwLjI1ODhDMTIuODYwNyA3LjEyODc2IDguOTgwNzEgNS41Nzg3NiA1Ljk3MDcxIDUuOTU4NzZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BeachAccess = createIcon('BeachAccess', [
  [
    'path',
    {
      d: 'M13.1277 14.5588L14.5577 13.1288L20.9977 19.5718L19.5707 20.9988L13.1277 14.5588ZM17.4207 8.82876L20.2807 5.96876C16.3307 2.01876 9.93071 2.00876 5.98071 5.94876C9.91071 4.64876 14.2907 5.69876 17.4207 8.82876ZM5.95071 5.97876C2.01071 9.92876 2.02071 16.3288 5.97071 20.2788L8.83071 17.4188C5.70071 14.2888 4.65071 9.90876 5.95071 5.97876ZM5.97071 5.95876L5.96071 5.96876C5.58071 8.97876 7.13071 12.8488 10.2607 15.9888L15.9907 10.2588C12.8607 7.12876 8.98071 5.57876 5.97071 5.95876Z',
      key: '27ectc',
    },
  ],
]);

export default BeachAccess;
